import { TrashIcon } from '@heroicons/react/24/outline';
import { useFormContext } from 'react-hook-form';

type DeleteButtonProps = {
    disabled: boolean;
    index: number;
    onDelete: (index: number) => void;
    onPopulate: () => void;
    onUpdateTotals: () => void;
};

function DeleteButton({ disabled, index, onDelete, onPopulate, onUpdateTotals }: DeleteButtonProps): JSX.Element {
    const { getValues } = useFormContext();

    function handleDelete(): void {
        onDelete(index);
        // if final line is non editable, calculate and update the line with remaining amount
        if (!getValues(`lines.${getValues('lines').length - 1}.amountEditable`)) {
            onPopulate();
        } else {
            onUpdateTotals();
        }
    }

    return (
        <div className="-ml-8 lg:ml-0">
            <button disabled={disabled} onClick={handleDelete} className="cursor-pointer disabled:cursor-default">
                <TrashIcon className="w-4 h-4 text-gray-500" />
            </button>
        </div>
    );
}

export default DeleteButton;
